module.exports = __webpack_public_path__ + "assets/img/d1.30fa93dc.jpg";